import React from "react";
import classes from "./Pagination.module.css";

const Dots = () => (
  <>
    <div className={classes.dotsContainerDesktop}>
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
        <circle cx="1" cy="1" r="1" fill="#1F1F1F"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
        <circle cx="1" cy="1" r="1" fill="#1F1F1F"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
        <circle cx="1" cy="1" r="1" fill="#1F1F1F"/>
      </svg>
    </div>
    <div className={classes.dotsContainerPhone}>
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
        <circle cx="1" cy="1" r="1" fill="#1F1F1F"/>
      </svg>
    </div>
  </>
);

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className = ""
}) => {
  if (totalPages <= 1) return null;

  const getPages = () => {
    const pages = [];
    
    if (totalPages <= 5) {
      // If 5 or fewer pages, show all pages
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // Always add first page
      pages.push(1);
      
      if (currentPage <= 3) {
        // First 3 pages: 1, 2, 3, 4, ..., last
        for (let i = 2; i <= 4; i++) pages.push(i);
        pages.push("dots");
      } else if (currentPage >= totalPages - 2) {
        // Last 4 pages: 1, ..., 8, 9, 10, 11
        pages.push("dots");
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        // Middle pages: 1, ..., current-1, current, current+1, ..., last
        pages.push("dots");
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push("dots");
      }
      
      // Add last page only if we haven't returned yet
      if (currentPage < totalPages - 2) {
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const getPagesPhone = () => {
    const pagesPhone = [];
    
    if (totalPages <= 4) {
      // If 5 or fewer pages, show all pages
      for (let i = 1; i <= totalPages; i++) pagesPhone.push(i);
    } else {
      // Always add first page
      pagesPhone.push(1);
      
      if (currentPage <= 2) {
        // First 3 pages: 1, 2, 3 ..., last
        for (let i = 2; i <= 3; i++) pagesPhone.push(i);
        pagesPhone.push("dots");
      } else if (currentPage >= totalPages - 1) {
        // Last 4 pages: 1, ..., 8, 9, 10, 11
        pagesPhone.push("dots");
        for (let i = totalPages - 2; i <= totalPages; i++) pagesPhone.push(i);
      } else {
        // Middle pages: 1, ..., current, ..., last
        pagesPhone.push("dots");
        pagesPhone.push(currentPage);
        pagesPhone.push("dots");
      }
      
      // Add last page only if we haven't returned yet
      if (currentPage < totalPages - 1) {
        pagesPhone.push(totalPages);
      }
    }

    return pagesPhone;
  };

  const pagesPhone = getPagesPhone();
 
  const pages = getPages();

  return (
    <>
      <div className={`${classes.pagination} ${className}`}>
        <button
          className={classes.arrow}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {currentPage === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 6.72018L6.74891 0L7.95099 1.19696L1.20208 7.91714L0 6.72018Z" fill="#CED1D5"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.74978 14L0 6.72018L1.25003 5.57164L7.99894 12.8518L6.74978 14Z" fill="#CED1D5"/>
              </svg>
          ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 6.72018L6.74891 0L7.95099 1.19696L1.20208 7.91714L0 6.72018Z" fill="#1F1F1F"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.74978 14L0 6.72018L1.25003 5.57164L7.99894 12.8518L6.74978 14Z" fill="#1F1F1F"/>
              </svg>
          )}
        </button>
        {pages.map((page, idx) =>
          page === "dots" ? (
            <span key={`dots-${idx}`} className={classes.ellipsis}><Dots /></span>
          ) : (
            <button
              key={`page-${page}-${idx}`}
              className={`${classes.page} ${currentPage === page ? classes.active : ""} semiboldMedium`}
              onClick={() => onPageChange(page)}
              disabled={currentPage === page}
            >
              {page}
            </button>
          )
        )}
        <button
          className={classes.arrow}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {currentPage === totalPages ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99894 7.27982L1.25003 14L0.0479515 12.803L6.79686 6.08286L7.99894 7.27982Z" fill="#CED1D5"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M1.24917 0L7.99894 7.27982L6.74891 8.42836L0 1.14817L1.24917 0Z" fill="#CED1D5"/>
          </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99894 7.27982L1.25003 14L0.0479515 12.803L6.79686 6.08286L7.99894 7.27982Z" fill="#1F1F1F"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M1.24917 0L7.99894 7.27982L6.74891 8.42836L0 1.14817L1.24917 0Z" fill="#1F1F1F"/>
          </svg>
          )}
        </button>
      </div>
      <div className={classes.paginationPhone}>
      <button
          className={classes.arrow}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {currentPage === 1 ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 6.72018L6.74891 0L7.95099 1.19696L1.20208 7.91714L0 6.72018Z" fill="#CED1D5"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.74978 14L0 6.72018L1.25003 5.57164L7.99894 12.8518L6.74978 14Z" fill="#CED1D5"/>
              </svg>
          ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 6.72018L6.74891 0L7.95099 1.19696L1.20208 7.91714L0 6.72018Z" fill="#1F1F1F"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.74978 14L0 6.72018L1.25003 5.57164L7.99894 12.8518L6.74978 14Z" fill="#1F1F1F"/>
              </svg>
          )}
        </button>
        {pagesPhone.map((page, idx) =>
          page === "dots" ? (
            <span key={`dots-${idx}`} className={classes.ellipsis}><Dots /></span>
          ) : (
            <button
              key={`page-${page}-${idx}`}
              className={`${classes.page} ${currentPage === page ? classes.active : ""} semiboldMiddle`}
              onClick={() => onPageChange(page)}
              disabled={currentPage === page}
            >
              {page}
            </button>
          )
        )}
        <button
          className={classes.arrow}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {currentPage === totalPages ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99894 7.27982L1.25003 14L0.0479515 12.803L6.79686 6.08286L7.99894 7.27982Z" fill="#CED1D5"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M1.24917 0L7.99894 7.27982L6.74891 8.42836L0 1.14817L1.24917 0Z" fill="#CED1D5"/>
          </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99894 7.27982L1.25003 14L0.0479515 12.803L6.79686 6.08286L7.99894 7.27982Z" fill="#1F1F1F"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M1.24917 0L7.99894 7.27982L6.74891 8.42836L0 1.14817L1.24917 0Z" fill="#1F1F1F"/>
          </svg>
          )}
        </button>
      </div>
    </>
  );
};

export default Pagination;
